import { OdontoConectaService } from "./odonto-conecta.service";
export function setData(odontoconecta) {
    return {
        type: 'odontoconecta/SET_DATA',
        payload: {
            odontoconecta
        }
    };
}
export function refreshOdontoConecta() {
    return async (dispatch, getState) => {
        const tegoserver = getState()['features/tego-server'];
        const odontoconecta = getState()['features/odontoconecta'];
        if (!odontoconecta.fetched || !tegoserver.isEnabled)
            return;
        try {
            const data = await new OdontoConectaService({ api: tegoserver.urls.odonto, ui: tegoserver.urls.ui }).fetchAllData(odontoconecta.appointment.id);
            dispatch(setData({ ...odontoconecta, fetched: true, appointment: data }));
        }
        catch (error) {
        }
    };
}
